import { InjectionToken } from '@angular/core';

/**
 * What an app-select-item needs from the app-select-search around it.
 *
 * This lives in its own file because SelectSearchComponent imports SelectItemComponent for its
 * content query; the item importing the select back would be an import cycle.
 */
export interface SelectSearchParent {
    isSelected(value: any): boolean;
    selectValue(value: any): void;
}

export const SELECT_SEARCH_PARENT = new InjectionToken<SelectSearchParent>('SELECT_SEARCH_PARENT');
